import privacyPolicy from './data/privacy-policy-cn'
import provisionStatement from './data/provision-statement-cn'
import provisionStatementCn from './data/provision-statement-cn-cn'
import analystRule from './data/analyst-rule-cn'
import cancelAccount from './data/cancel-account-cn'
import quoteService from './data/quote-service-cn'
import thirdPartyShare from './data/third-party-share-cn'
import thirdPartyShareCn from './data/third-party-share-cn-cn'
import biometricAuthentication from './data/biometric-authentication-cn'
import communityRule from './data/community-rule-cn'
import communityRuleCn from './data/community-rule-cn-cn'
import communityPrivilegeRule from './data/community-privilege-rule-cn'
import communityIncomeRule from './data/community-income-rule-cn'
import eventTerms from './data/event-terms-cn'
import ipoSubscriptionStatement from './data/ipo-subscription-statement-cn'
import conditionOrderDisclaimer from './data/condition-order-disclaimer-cn'

import thirdPartyShareGoogle from './data/third-party-share-google-cn'

import provisionStatementGoogle from './data/provision-statement-google-cn'

import financingPowerExplain from './data/financing-power-explain-cn'

export default {
  // 通用翻译
  common: {
    confirm: '确定',
    return: '返回',
    cancel: '取消',
    noData: '暂无数据',
    noInfo: '暂无相关信息',
    reminder: '温馨提示',
    pleaseGoAppHandle: '请前往app操作',
    reqError: '请求失败，请稍后重试',
    handleError: '操作失败，请重试',
    paramError:"参数错误",
    open:"打开",
    openAccountTip:"开户提示",
    gotoOpenAccount:"您尚未完成开户，是否前去开户？",
    updateAppTips:"当前App版本暂不支持一键跳转，请升级至最新版本体验",
    info:"资讯"
  },

  router: {
    winbull: '盈宝证券',
    helpCenter: '帮助中心',
    privacyPolicy: '隐私政策',
    provisionStatement: '服务协议',
    analystRule: '分析师规则',
    cancelAccount: '注销账号',
    quoteService: '盈宝行情服务协议',
    thirdPartyShare: '第三方共享信息情况说明',
    biometricAuthentication: '生物认证服务条款',
    communityRule: '社区规则',
    communityPrivilegeRule: '社区权益规则',
    communityIncomeRule: '奖励规则',
    eventTerms: '活动条款',
    ipoSubscriptionStatement: '盈宝证券(香港)新股认购声明',
    conditionOrderDisclaimer: '条件单风险声明',
    tradeTerm: '说明',
    financingPowerExplain: '融资购买力说明',
    aiAnalysis: '盈宝AI股票分析',
    feedBackQuestion:"问题反馈",
    newDetail:"资讯详情",
    kline: 'K线形态',
    shareOption: '期权动态解读',
    magicNineTurns:"神奇九转",
    winbullAiInfo:"盈宝AI资讯",
    activityInfo:"活动详情",
    fastInfo:"快讯",
    winbullActivity:"盈宝活动",
  },

  helpIndex: {
    type0: '证券问题',
    type1: '社区问题'
  },

  search: {
    searchBarInputHolder: '请输入您想了解的内容',
    fapTitle: '常见问题',
    searching: '搜索中',
    noSearch: '未搜索到与',
    hasSearch: '搜索到与',
    relatedInformation: '相关内容',
    totol: '共',
    strip: '条',
    loadMore: '加载更多'
  },

  aiAnalysis: {
    analyzing: '分析中…',
    analyzingResult: '分析答案中…',
    dataLoading: '数据加载中...',
    analyResult: '分析答案',
    finishAnalyResult: '分析答案完成',
    refreshAnalysis: '重新分析',
    aiTip: '提示：AI分析“基于Deepseek- R1”的深度推理，内容均为AI生成，仅供分析参考，不构成直接投资建议。',
    aiTip2: '提示：当前内容由AI基于交易日',
    aiTip3: '行情资讯数据进行分析，内容均为AI生成，仅供分析参考，不构成直接投资建议',
    pressureLevel: '压力位',
    supportLevel: '支撑位',
    recommendedLevel: '推荐等级',
    bullish: '看多',
    strong_bullish: '强烈看多',
    bullish2: '看涨',
    neutral: '中性',
    neutral2: '中性',
    bearish: '看空',
    strong_bearish: '强烈看空',
    bearish2: '看跌',
    help_less:"没有帮助",
    data_error:"数据错误",
    other:"其他反馈",
    submit:"提交",
    type:"类型",
    enter_feed_back:"您的反馈，驱动我们成长",
    thanksYourFeedBack:"感谢您的反馈，我们将持续优化产品体验",
    useful:"有用",
    feedBack:"反馈",
    share:"分享",
    relateInfo:"相关AI资讯",
    shareTitle:"AI股票分析",
    shareDesc:"ai分析内容",
    newTip:"资讯由AI检索生成，请谨慎甄别，不作为投资建议。",
    outNewTip:"即将跳转外部链接，请谨慎甄别信息",
    viewOrigin:"查看引用来源",
    auoteInfo:"资讯由AI根据市场热点和股票检索获取，并由AI进行整理和情绪判断，仅供参考，不构成投资建议。",
    urlIsNull:"当前链接不存在，请稍后再试...",
    connectInfo:"引用资讯",
    recommendRead:"推荐阅读",
    emptyInfo:"暂无相关资讯",
    fastAuoteInfo:"快讯信息由AI基于公开市场信息检测、分析、整理生成，仅供参考，不构成投资建议。",
    closePrice:"收盘价",
    analysisTip:"提示：当前内容由AI基于当天行情资讯数据进行分析，内容均为AI生成，仅供分析参考，不构成直接投资建议"
  },

  doc: {
    privacyPolicy: privacyPolicy,
    provisionStatement: provisionStatement,
    provisionStatementCn: provisionStatementCn,
    analystRule: analystRule,
    cancelAccount: cancelAccount,
    quoteService: quoteService,
    thirdPartyShare: thirdPartyShare,
    thirdPartyShareCn: thirdPartyShareCn,
    biometricAuthentication: biometricAuthentication,
    communityRule: communityRule,
    communityRuleCn: communityRuleCn,
    communityPrivilegeRule: { ...communityPrivilegeRule },
    communityIncomeRule: communityIncomeRule,
    eventTerms: eventTerms,
    ipoSubscriptionStatement: ipoSubscriptionStatement,
    conditionOrderDisclaimer: conditionOrderDisclaimer,
    thirdPartyShareGoogle: thirdPartyShareGoogle,
    provisionStatementGoogle: provisionStatementGoogle
  },

  financingPowerExplain: financingPowerExplain,

  usOption:{
   contractInfo:"合约要素",
   contractAttibute:"合约属性",
   contractAttibute1_title:"行权价",
   contractAttibute1:"期权中对标的资产买入或卖出的约定价格，期权价值高度依赖于当前标的价格与行权价的关系。",
   contractAttibute2_title:"到期日",
   contractAttibute2:"期权合约有效的最后日期，到期后合约失效。期权分为欧式（只能在到期日行权）和美式（可在到期日前任何时间行权）。",
   contractAttibute3_title:"合约规模",
   contractAttibute3:"每张期权代表多少单位的标的资产，美股标准1张期权=100股标的股票，例如买入一张特斯拉的Call，即代表拥有未来以特定价格买入100股特斯拉股票的权利。（当标的股票发生公司行动时，合约规模可能会发生相应调整）。",
   contractAttibute4_title:"合约乘数",
   contractAttibute4:"每张期权合约对应标的资产价值的乘数，比如乘数为 100，行权价为 200美元，代表该合约对应价值为 100*200 = 20000美元。",
   contractAttibute5_title:"内在价值",
   contractAttibute5:"期权标的价格与行权价之间的有利差额，代表期权在当前时间立即行权所能产生的潜在收益。",
   contractAttibute51:"看涨期权 (Call)：内在价值 = max (标的价格 – 行权价, 0)。",
   contractAttibute52:"看跌期权 (Put)：内在价值 = max (行权价 – 标的价格, 0)。",
   contractAttibute6_title:"时间价值",
   contractAttibute6:"期权价格中超出内在价值的部分，反映期权在到期前有变得获利的时间潜力，时间价值会随着期权到期日的逐近而衰减，最终在到期日变为零。",
   contractAttibute61:"时间价值 = 期权的市场价格 - 内在价值。",
   
   optionIndex:"期权指标",
   optionIndex1_title:"隐含波动率",
   optionIndex1:"市场对标的资产未来波动性的预期，隐含波动率越高，意味着市场预期未来价格波动越大，期权价格越高。",
   optionIndex2_title:"溢价",
   optionIndex2:"衡量当前期权价格相对于其内在价值的超额溢价程度，反应市场对未来波动和时间价值的溢价支付意愿。",
   optionIndex3_title:"杠杆倍数",
   optionIndex3:"表示当采用期权来控制同等数量标的资产所需的资金，期权权利金相比于购买标的资产本身所需资金的比率，代表资金的杠杆效应。",
   optionIndex31:"杠杆倍数 = 资产标的价格 / 期权价格。",
   optionIndex4_title:"有效杠杆",
   optionIndex4:"衡量期权价格百分比变动相对于标的资产价格百分比变动的倍数，直接反映了期权收益率相对于标的资产收益率的放大倍数。",
   optionIndex41:"有效杠杆 = Delta*杠杆倍数。",

   greekAlphabet:"希腊字母",
   greekAlphabet1_title:"Delta",
   greekAlphabet1:"代表期权价格对标的资产价格变化的敏感性，对于Call期权，假设Delta=0.6，表示标的股票上涨$1，理论上期权价格将上涨$0.6。",
   greekAlphabet2_title:"Gamma",
   greekAlphabet2:"表示Delta对标的资产价格变化的敏感度，即标的价格每波动1美元，Delta的变化量。Gamma值越大，Delta变化越快，期权对标的价格波动越敏感。",
   greekAlphabet3_title:"Vega",
   greekAlphabet3:"代表期权价格对标的资产波动率变化的敏感性，假设Vega=0.25，表示标的资产波动率上涨1%时，期权价格上涨$0.25。",
   greekAlphabet4_title:"Theta",
   greekAlphabet4:"代表期权价格随时间衰减的变化率（时间价值损耗），Theta值一般为负数，表明随着时间推移，期权价值将减少。",
   greekAlphabet5_title:"Rho",
   greekAlphabet5:"代表期权价格对无风险利率变化的敏感性，若Rho=0.4，表示利率上涨1%时，期权价格上涨$0.4。",

   priceCaculator:"期权价格计算器",
   caculatorDesc1:"期权价格计算器是一款简单实用的金融工具，帮助您在交易决策中，计算期权的理论价格。影响期权金的主要因素有：",
   caculatorDesc2:"正股价格、剩余到期时间、隐含波动率，",
   caculatorDesc3:"通过修改任一参数，可以计算出期权新的理论价格。",
   caculatorDesc4:"期权价格计算器采用的是Black-Scholes 期权定价模型和针对美式期权的二叉树模型计算得出。Black-Scholes 期权定价模型是金融史上最具影响力的模型之一，由经济学家 Fischer Black 和 Myron Scholes 于1973 年提出，并因此荣获 1997 年诺贝尔经济学奖。该模型提出的 BSM（Black-Scholes-Merton）公式，被誉为20 世纪最伟大的金融公式，也是“全球最美十大公式”之一。",
   caculatorDesc5:"示例1",
   caculatorDesc51:"买入期权时，判断期权当前价格是否合理",
   caculatorDesc52:"当前某期权的市场报价为$3.20，但计算器显示其理论价格为$2.70，说明市场可能存在过热，需谨慎入场。",
   caculatorDesc6:"示例2",
   caculatorDesc61:"通过判断正股价格涨跌买卖期权",
   caculatorDesc62:"当前某股票正股价格为$3.0，您持有该股票的Call期权，并预期今天该股票最高可以涨至$3.5。您可以在期权计算器修改正股价格为$3.5，得出持有期权的理论价格，并以该理论价格为参考挂单将期权平仓卖出。",
   caculatorDesc7:"示例3",
   caculatorDesc71:"评估期权的时间损耗",
   caculatorDesc72:"您持有一个Call期权，想要知道在未来5天，如果正股价格持续震荡（几乎无涨跌）的场景下，期权的时间损耗。您可以在期权计算器修改到期日，得出5天后期权的理论价格。",
   caculatorDesc8:"免责声明：盈宝证券致力于确保期权计算器依据模型所得结果准确性，无法保证结果绝对无误。所有计算结果仅供参考之用，不构成任何投资建议。",
   whatIsOptionCaculator:"什么是期权计算器？",
   optionCaculatorDemo:"期权计算器示例场景"
  },
  kline: {
    mainTitle1: 'K线形态由多根K线的开盘价、收盘价、最高价和最低价共同构成，是价格运行的直观结构表达。它反映了市场多空力量的转换与博弈，可辅助识别趋势方向与潜在的反转或延续信号。',
    mainTitle2: '由于K线形态本身并非确定性工具，实际中应结合趋势结构、成交量变化、技术指标及基本面因素进行综合研判，以提高分析的可靠性与交易决策的质量。',
    titleTips: '盈宝证券致力于提供股票K线形态信号识别的准确性，无法保证结果绝对无误。该信号结果仅供参考之用，不构成任何投资建议',
    title1: '弃婴看涨',
    title2: '弃婴看跌',
    title3: '刺穿线',
    title4: '乌云盖顶',
    title5: '锤子线',
    title6: '上吊线',
    title7: '启明星',
    title8: '黄昏之星',
    title9: '三个白武士',
    title10: '三只乌鸦',
    title11: '多方炮',
    title12: '空方炮',
    title13: '看涨吞没',
    title14: '看跌吞没',
    title15: '上升三法',
    title16: '下降三法',
    title17: '平头底',
    title18: '平头顶',
    desc1: '底部反转信号。第一根为下跌长阴，第二天跳空低开形成十字星，与前后K线无重叠，第三天大阳线高开高走并收回前阴部分。显示空方能量耗尽，多方接管，常出现在明显下跌末期，是较强的见底信号。',
    desc2: '顶部反转信号。第一根上涨长阳，第二天跳空高开形成十字星，与两侧K线脱离，第三天长阴线低开低走并跌入前阳实体，表明多头力量衰竭，空头接管。多见于强势上涨后，预示趋势反转可能。',
    desc3: '底部反转信号。先是一根长阴线，次日低开但强势拉升，收盘价站上前阴实体中部以上，显示多方积极进攻，空头压力减弱。常出现在连续下跌后的企稳阶段，是短期反弹信号。',
    desc4: '顶部反转形态。先出现一根长阳线，次日跳空高开但收盘大幅下挫，跌破前阳线实体中部，显示多头上攻受阻，空头反击有效。若伴随放量，反转信号更强，预示上涨趋势可能终结。',
    desc5: '底部反转信号。实体短、下影线长，上影极短或无，说明空头曾大幅打压但被多头吸收并反攻。常出现在下跌末端，显示下方买盘活跃。若次日有阳线确认，止跌企稳信号较强。',
    desc6: '顶部警示形态。实体较短、下影线很长，上影极短或无，多见于上涨末期。说明盘中出现较大抛压，虽被多头回收，但显示多头力量开始衰减。若第二天出现阴线确认，反转概率提升。',
    desc7: '底部反转形态。先长阴下跌，第二天跳空小实体，第三天长阳强势收复前阴。显示空头衰竭，多头主导行情。若伴随放量和均线支撑，是较强的见底信号。',
    desc8: '顶部反转形态。第一天长阳上涨，第二天跳空小实体，第三天长阴线跌回前阳实体内。显示上涨动能减弱、空头力量接管。若伴随高位放量，是强烈的见顶信号，常预示趋势转空。',
    desc9: '连续三根长阳线，收盘价逐步抬高，买盘持续增强。多见于下跌末期或震荡整理后，预示多头掌控局面。若成交量同步放大，是强烈的上涨延续信号。',
    desc10: '连续三根长阴线，收盘价逐步走低，实体接近最低点，显示空头强势占优。通常出现在高位，代表上涨趋势结束，市场转向下跌。成交量放大时信号更可靠。',
    desc11: '上涨趋势中，先阳后阴再接阳。中间阴线未破支撑，多头快速反攻并延续上行。反映市场回调有限，多方力量占优。',
    desc12: '下跌趋势中，先阴后阳再接阴。中间阳线未能突破关键阻力，空头迅速反击并延续下跌。显示市场反弹无力，空方主导趋势。',
    desc13: '小阴线后出现更长阳线完全吞没前一根实体。显示多方力量强劲，空头退场。若伴随底部放量，是常见的反转信号，预示行情可能上行。',
    desc14: '小阳线后大阴线完全吞没前阳，空头力量强势反扑。常见于顶部或反弹末端，显示上涨动能衰退，是短线转空信号。',
    desc15: '先一根长阳，随后数根小阴回调震荡不破关键支撑，最后再接长阳线突破上行。多方主导行情，属于上涨中继形态，显示趋势稳固。',
    desc16: '先一根长阴，随后数根小阳在其区间内震荡，最后再接长阴线下破。显示空方暂缓后再次发力，延续下跌趋势，属于下跌中继形态。',
    desc17: '连续多根K线的下影低点基本持平，显示下方支撑强劲，抛压逐渐被吸收。常出现在下跌末端，若随后出现阳线突破，是筑底反转信号。',
    desc18: '连续多根K线上影高点接近同一水平，显示上方压力沉重。上涨乏力，易引发回调或反转。若随后的K线为阴线，信号更强烈。',
  },
  warrantStatement:{
    hkWarrantStatement:"港股权证字段说明",
    rotationInfo:"轮证介绍",
    warrant_title:"窝轮（Warrant）",
    warrant_desc:"即认购认沽权证，由发行人赋予持有人在到期日按行使价买入（认购）或卖出（认沽）相关资产的权利，投资权证实质上是对基础资产价格方向的杠杆化投资，窝轮无强制收回机制。",
    cbbc_title:"牛熊证（CBBC）",
    cbbc_desc:"牛熊证为一种杠杆型结构性投资产品，用于追踪基础资产的价格表现，一旦基础资产价格触及赎回价格，发行人将强制赎回，产品终止交易，剩余价值取决于赎回时的结算价格，可能低至零。",

    namingRule:"命名规则",
    namingRule_info:"【资产简称】+【发行商简称】+【到期年份/月份】+【方向】+【行使价或序列号】",
    namingRule_detail1:"对于窝轮，看涨看跌分别用“购”、“沽”表示；对于牛熊证，看涨看跌分别用“牛”、“熊”表示；",
    namingRule_detail2:"到期年份一般以数字表达，例如2026年到期，则以数字“六”；",
    namingRule_detail3:"到期月份中，1月至10月以数字表达（一、二...十），11月、12月分布以“甲”、“乙”代表；",
    namingRule_detail4:"序列号为同一发行商就同一资产发行同一到期年月的衍生权证进行序列编号（A,B,C...或1,2,3...）；",

    publicFieldStatement:"公有字段说明",
    publicFieldStatement_title1:"街货量/街货比",
    publicFieldStatement_desc1:"市场上尚未被发行商回收、由投资者持有的权证数量及其占发行总量的比例。街货量或街货比越高，说明投资者持有的权证数量越多，此时权证价格越受市场供求影响。",
    publicFieldStatement_title2:"溢价",
    publicFieldStatement_desc2:"表示买入权证并行使权利取得正股，相较于直接买入正股所需承担的额外成本。溢价越高，正股需有更大价格变动，权证才具备盈利空间。",
    publicFieldStatement_title3:"打和点",
    publicFieldStatement_desc3:"在到期日，权证投资者实现不盈不亏时，正股所需达到的价格水平。正股价格需超过（认购）或低于（认沽）打和点，权证才可能产生收益。",
    publicFieldStatement_title4:"换股价",
    publicFieldStatement_desc4:"按权证条款折算后，行使权证换取正股所对应的等效价格。该价格反映投资者通过权证参与正股的实际成本。",
    publicFieldStatement_title5:"换股比率",
    publicFieldStatement_desc5:"行使权证时，所需权证份数与可换取正股数量之间的比例关系，换股比率决定权证价格与正股价格之间的换算方式。",
    publicFieldStatement_title6:"行使价",
    publicFieldStatement_desc6:"权证合约中约定的正股买入价（认购）或卖出价（认沽），正股价格需相对行使价处于有利位置，权证才具备内在价值。",
    publicFieldStatement_title7:"杠杆比率",
    publicFieldStatement_desc7:"在其他条件不变的情况下，权证价格相对于正股价格变动的放大倍数。杠杆比率越高，价格波动幅度与投资风险越大。",
    publicFieldStatement_title8:"最后交易日",
    publicFieldStatement_desc8:"权证在交易所可进行买卖的最后一个交易日，超过该日期，权证将停止交易。",
    publicFieldStatement_title9:"到期日",
    publicFieldStatement_desc9:"权证合约正式到期并进行现金结算或价值确认的日期，到期时若未符合行权条件，权证可能失去全部价值。",
    
    warrantFieldStatement:"窝轮专属字段说明",
    warrantFieldStatement_title1:"引伸波幅",
    warrantFieldStatement_desc1:"由权证或衍生产品市场价格反推得出的正股未来价格波动预期水平。引伸波幅越高，代表市场预期正股未来波动越大，在其他条件不变的情况下，引伸波幅上升通常有利于权证价格。",
    warrantFieldStatement_title2:"对冲值",
    warrantFieldStatement_desc2:"正股价格每变动一个单位时，权证理论价格的对应变动幅度。对冲值介乎 0 至 1（认购）或 0 至 -1（认沽），数值越接近 1（或 -1），权证价格走势越接近正股。",

    bullAndBearFieldStatement:"牛熊证专属字段说明",
    bullAndBearFieldStatement_title1:"收回价",
    bullAndBearFieldStatement_desc1:"牛熊证条款中设定的强制收回价格水平。当正股或相关指数触及收回价，产品将即时终止，投资者可能只获得极低甚至零的剩余价值。",
    bullAndBearFieldStatement_title2:"距收回价",
    bullAndBearFieldStatement_desc2:"现时正股价格与牛熊证收回价之间的差距，通常以价格或百分比表示。距离越小，触发强制收回的风险越高；距离越大，短期内被收回的风险相对较低。",
  },
  shareOption: {
    title: '股票市场信息繁杂，期权具有高杠杆与低成本试错的特性，“聪明钱”往往倾向通过期权提前布局潜在消息，期权动态数据可以帮你从纷繁数据中，提炼出资金动向与市场情绪变化。',
    title1: '期权异动',
    desc11: '当某个期权合约突然出现大单成交、异常放量或隐含波动率急剧变化时，通常意味着：',
    desc12: '期权异动并不等同于“必然方向”，但往往是值得重点跟踪的风险与机会信号源。',
    desc1li11: '市场对某一事件或预期产生了明显分歧或共识',
    desc1li12: '大资金正在提前建仓或调仓',
    desc1li13: '可能有部分参与者提前对潜在消息作出反应',
    title2: '期权成交榜',
    desc21: '成交榜反映的是当日最活跃的期权合约：',
    desc1li21: '成交量高 → 流动性强、买卖价差小',
    desc1li22: '成交活跃 → 多空博弈集中，情绪更容易在这些合约上放大',
    desc1li23: '标的越靠前 → 市场关注度越高，往往对应当下的热门主题或事件',
    title3: '期权持仓榜',
    desc31: '  如果说成交量反映的是当下的“热度”，那么持仓量（未平仓合约数量）更像是市场的“态度”，通过持仓榜，你可以观察：',
    desc1li31: '哪些股票或指数被持续、长期关注',
    desc1li32: 'Put/Call 哪一侧持仓更重，反映中长期多空力量对比',
    desc1li33: '结合执行价分布，可大致判断市场对未来走势的偏乐观还是偏保守',
    title4: '财报期权',
    desc41: '每到财报季，期权市场会变得格外敏感，财报期权可以做为业绩发布前的“押注地图”：',
    desc1li41: '哪些股票即将发布财报，提前锁定潜在波动标的',
    desc1li42: 'Put/Call 的持仓量比、成交量，观察市场对财报结果的押注方向',
    tips: '期权动态内容仅用于市场信息展示与一般性分析说明，不构成任何形式的投资建议、买卖邀约或承诺。',
  },
   portfolio: {
    portfolioIntroduction:"盈宝投资组合",
    portfolioIntroductionMore:"盈宝投资组合",
    investPortfolio:"投资组合",
    fundInventment:"基金投资",
    purchaseActualAssets:"买入实际股票资产",
    purchaseFundShares:"买入基金份额",
    managementFeeOnly:"只收管理费",
    managementFee:"管理费",
    serviceFee:"服务费",
    hostingFeeEtc:"托管费等",
    discloseHoldAndTrade:"持仓、交易完全披露",
    discloseHoldTopTen:"每季度披露前十持仓",
    regularlyReleaseStrategy:"定期发布组合策略洞察",
    releaseLessInterpretation:"极少发布基金策略解读",
    openEntrustedAccount:"开立盈宝投资组合全权委托账户",
    choicePortfolioAndInvested:"选择组合投入并划转投入资金",
    autoPurchaseStockForYourAssets:"盈宝根据组合资产配置，自动为您买入组合成分股",
    viewEarnDetailAfterPurchase:"组合成分股买入成功后，可查看组合每日收益明细",
    autoAdjustHoldForMonitor:"实时监测组合持仓，并根据组合策略为您自动调仓",
    portfolioConstitute:"投资组合是由",
    stockAndBondEtfCashEtc:"股票、债券、ETF、现金等",
    moreCategoryFinanceSchame:"多类金融资产构成的整体配置方案",
    professionalTermManage:"盈宝投资组合由专业投研团队统一管理，根据客户的收益目标与风险偏好进行科学配置，覆盖资本增长、稳健收益及区域投资等需求。通过多资产、多维度分散配置，在有效控制风险的同时，力求实现长期稳健的投资回报",
    professionalManage:"专业管理",
    serviceProvideForFinanceTerm:"资深金融团队提供专业、可靠的理财服务",
    disciplinedInvesting:"纪律投资",
    avoidForMarketAttitude:"避免投资受市场情绪左右，保持组合最优状态",
    brokenStockTrade:"碎股交易",
    premiumAssetsForFiveHundred:"低至500美元即可投一篮子优质资产，分散投资",
    extremelyLowCost:"极低成本",
    noCommissionAndPlatformFee:"除了极低第三方交易代收费，无佣金和平台费",
    coreConfiguration:"核心配置债券类ETF，灵活配置少量股票类ETF，不错过热点机会",
    assetDiversification:"资产分散，降低单一市场与单一资产风险，关注回撤管理，提升持有过程的舒适度",
    avoidEmotionality:"结合量化数据模型和AI技术进行投资决策，避免个人情绪化投资",
    noLockPeriod:"无锁定期，随时认购、赎回",
    lowThresholdParticipation:"低门槛参与，充分释放闲置资金价值",
    zeroSubscriptionFee:"零认购费，月度管理费低至 0.1%",
    incomeSinceBuild:"成立以来10个自然季度中，8个季度实现正收益",
    incomeRate:"收益率",
    portfolioIncome:"组合收益",
    wenyingbao:"稳盈宝",
    robustConfiguration:"稳健配置，坚如磐石",
    lowerMaximumDrawdown:"经历中美贸易战、硅谷银行危机等事件，组合仍保持低至 -3.36%的最大回撤",
    dataTipForBottom:"*数据说明见底部",
    steadyPaceLeads:"行稳致远，向上而行",
    reasonableParticipation:"合理参与市场上行机会，实现稳中求进的长期目标",
    peaceMindAndAssured:"安心、放心、省心",
    professionalProtection:"放下投资焦虑，我们的专业团队时刻在背后守护",
    robustnessPrinciple:"稳健配置的策略核心原则",
    historyIncomePerformance:"历史收益表现",
    EfficientCapitalOperation:"兼顾交易与理财，让资金高效运转",
    resultDataTip:"*数据说明：本页面所展示的数据为截至 2026-01-05 的投资组合实际业绩统计结果。",
    riskTip:"*风险提示：投资组合过往业绩不预示未来表现。请在选择投资组合服务前，确认该组合符合自身的风险承受能力、投资期限和投资目标。",
    strictSelectionEtf:"严选ETF",
    stockRelatedEtf:"以股票类ETF",
    configureHost:"为主进行配置",
    dynamicAdjustment:"动态调整",
    withMarketChanges:"随市场变化",
    optimizeAssets:"优化股债资产比例",
    disciplineEnforcement:"纪律执行",
    followStrategicRules:"遵循策略规则",
    avoidEmotionalTrading:"避免情绪化操作",
    noLockPeriodForReturn:"无锁定期，随时认购、赎回",
    lowThresholdReleaseFunds:"低门槛参与，充分释放闲置资金价值",
    noSubscriptionAndLowerManageFee:"零认购费，月度管理费低至 0.1%",
    yingduoduo:"盈多多",
    onlySetEtf:"仅配置ETF，不直接配置个股",
    moreQuaterPositive:"多季度实现正收益",
    strictlyControlDrawdown:"严控回撤，享受更平稳持续的收益体验",
    yingduoduoAdvantage:"盈多多投资组合优势",
    bothTradingAndFinancial:"兼顾交易与理财，让资金高效运转",
    yingduoduoRiskTip:"*风险提示：投资组合过往业绩不预示未来表现。请在选择投资组合服务前，确认该组合符合自身的风险承受能力、投资期限和投资目标。",
    researchDeep:"深度研究",
    priorityResearchPpportunity:"重点研究股票资产配置机会",
    riskManage:"风险管理",
    bufferingPortfolioVolatility:"以债券配置缓冲组合波动",
    profitBalance:"收益平衡",
    bothBenefitsAndRisks:"兼顾收益与风险，提升投资体验",
    cumulativeIncome:"累计收益",
    annualizedVolatility:"年化波动率",
    maximumDrawdown:"最大回撤",
    youxuanbeimeiDataTip:"统计数据为截止时间至2026-01-05，优选北美组合成立以来的实际收益数据，业绩基准为SPDR彭博1-3月美国国库券ETF*10%+SPDR标普500指数ETF*90%",
    preferredBeimeiPortfolio:"优选北美组合",
    performanceBenchmark:"业绩基准",
    annualizedVolatilityTip:"年化波动率是衡量投资组合收益波动程度的指标，代表组合收益变化的幅度。波动越大，说明收益起伏越剧烈。",
    youxuanbeimei:"优选北美",
    highQualityStocks:"北美优质股票 锁定增长潜力",
    targetAnnualizedIncome:"目标年化收益＞10% ，捕捉向上周期行业",
    mediumLongAllocation:"中长期视角资产配置，优选行业核心龙头",
    moreIndustryInvestment:"多行业分散投资，争取获得更均衡的回报",
    scientificAllocation:"科学配置，确保增长之路上的安全",
    quantitativeModel:"建立量化数据模型，科学研判资产投资价值",
    hedgingStrategy:"适时建立对冲策略，降低市场波动影响",
    bigDataAndAi:"大数据和AI辅助决策，实时监控市场波动",
    surpassMarketIncome:"超越市场收益，波动更小、回撤更低",
    followThemarket:"跟随市场脉动，捕捉市场机会",
    highMarketCompanies:"高市值企业，低投资门槛",
    suitableForInvestors:"适合投资者",
    beimeiyouxuanRisk:"*风险提示：投资组合过往业绩不预示未来表现。请在选择投资组合服务前，确认该组合符合自身的风险承受能力、投资期限和投资目标。",
    lowThresholdTo:"投资组合投资门槛低至",
    subscribeAnyTime:"随时申购",
    flexibleTransfer:"灵活转出",
    matureMarket:"偏好成熟市场",
    diversifiedInvestment:"偏好多元化投资",
    longTermInvestment:"立足长期投资",
    suitableRobustInvestors:"适合追求稳健长期收益投资者，在不确定的市场中获得稳定的财富增长",
    assetGrowth:"以权益资产为增长引擎，辅以债券配置平抑波动，力争更优风险回报比",
    whyPortfolio:"什么是投资组合？",
    howExcutePortfolio:"我们如何帮您执行组合投资？",
    differentWithFunds:"投资组合与基金有什么不同？",
    whyChoicePortfolio:"为什么选择投资组合？",
    fullDelegationService:"全委托投资组合服务",
    whyPortfolioIsBest:"- 为什么投资组合是最好的长期投资方式 -",
    moreImportantInvestment:" 有研究表明，长期投资中约70%–90% 的收益来自资产配置，而非择时或个股选择；",
    reduceAssetRisk:" 组合资产分散配置，在保持长期收益潜力的同时，有效降低风险；",
    reasonableInvestmentPlan:" 投资组合本质不是选股，而是选择一套与风险需求匹配的投资方案；",
    dsignForLongTime:"- 盈宝投资组合：为长期投资而设计 -",
    assetLowThresholdTo:"投资一揽子优质股票资产门槛低至",
    transactionTransparency:"组合配置、调仓交易清晰透明",
    longTermValidation:"组合策略经过较长周期的实际运行与验证",
    portfolio:"组合",
    riskLevel:"风险等级",
    riskLevelLowMedium:"中低风险",
    riskLevelMedium:"中风险",
    buildDays:"成立天数",
    annualizedIncome:"年化收益",
    investmentTarget:"投资目标",
    steadyAppreciation:"稳健增值",
    growthFirst:"成长优先",
    regionalCoreAssets:"区域核心资产",
    targetAudience:"适合人群",
    lowVolatilityPreference:"低波动偏好",
    balancedReturn:"均衡收益型",
    aggressiveAllocation:"进取配置型",
    portfolioDataTip:"*数据统计时间截至2026-06-30，投资组合过往业绩不预示未来表现。请在选择投资组合服务前，确认该组合符合自身的风险承受能力、投资期限和投资目标。",
    highQualityPortfolio:"- 优质组合，成就长期投资的力量 -",
    investmentAmount:"投资金额",
    scenarioSimulation:"基于10,000美元初始投资的组合收益情景模拟",
    investmentTerm:"投资时长",
    year:"年",
    scenarioSimulationTip:"*组合收益测算基于历史年化表现进行推算，仅作情景示例，不构成收益承诺。过往业绩不代表未来表现。",
    portfolioInvestmentSystem:"- 为长期而构建的组合投资体系 -",
    carefullyHighQualityEtf:"严选优质ETF与核心资产，构建专业化底层配置；",
    aiQuantitativeModel:"基于宏观周期框架与AI量化模型，识别市场轮动阶段；",
    modelDriven:"以战略资产配置为核心，模型驱动长期结构方向；",
    strengthenBacktesting:"强化回撤管理与波动控制，提升持有体验与稳定性。",
    customerIncome:"- 陪伴客户走过的投资旅程 -",
    customer:"客户",
    portfolioName:"组合名称",
    startTimeForInvest:"开始投资时间",
    holdIn:"持有",
    sky:"天",
    totalIncomeRate:"累计收益率",
    customerName:"客户姓名",
    holdInDays:"持有自然日",
    cusIncomeDataTip:"*数据来自盈宝部分真实客户历史投资记录统计，追加投入、部分转出可能导致累计收益率统计产生差异，数据仅作为历史展示，不构成任何投资建议或收益承诺。",
    nomalQuestion:"- 常见问题 -",
    whoManagePortfolio:"投资组合由谁管理",
    whoManagePortfolioDesc:"盈宝提供全权委托投资管理服务。您的投资组合由盈宝专业投资团队全权负责，包括资产配置、动态调仓、风险控制等日常管理。",
    investPortfolioLockTerm:"投资组合是否设最低投资金额或锁定年期",
    investPortfolioLockTermDesc:"最低起投金额为500美元，无任何锁定期。您可随时提交申购或赎回申请。",
    howLongTimeForUpdate:"投资组合收益数据多久更新",
    howLongTimeForUpdateDesc:"投资组合净值及持仓数据每个交易日更新一次。通常于交易日下午5:00，APP会以最新收市价格及当日持仓情况完成数据刷新。",
    howLongTimeAdjust:"投资组合多久调仓一次",
    howLongTimeAdjustDesc:"调仓频率并非固定，而是由策略驱动。我们会根据市场环境、资产估值与风险特征，定期进行组合再平衡，并在必要时主动调整以优化风险收益特征或控制下行风险。所有调仓操作均不收取额外费用。",
    whiceFeeForPortfolio:"买卖投资组合需要支付哪些费用",
    whiceFeeForPortfolioDesc1a:"盈宝坚持极致低成本原则，对于投资组合，",
    whiceFeeForPortfolioDesc1b:"不收取",
    whiceFeeForPortfolioDesc1c:"以下任何费用：",
    whiceFeeForPortfolioDesc11:"平台管理费",
    whiceFeeForPortfolioDesc12:"经纪佣金",
    whiceFeeForPortfolioDesc13:"申购费",
    whiceFeeForPortfolioDesc14:"赎回费",
    whiceFeeForPortfolioDesc2:"实际收取的费用仅包括两类：",
    whiceFeeForPortfolioDesc21:"投资组合管理费：由盈宝收取，费率因不同组合而异，请参阅具体组合详情页。",
    whiceFeeForPortfolioDesc22:"第三方机构费用：包括交易所收取的交易经手费、监管费、分红预扣税、ADR托管费等。这些为市场通行费用，盈宝仅代收代付，不额外加收任何平台费或佣金。",
    howToViewFeeDetail:"如何查看已支付的管理费明细",
    howToViewFeeDetailDesc1:"管理费通常于每月第一个工作日计提上月费用。您可通过以下方式查看：",
    howToViewFeeDetailDesc11:"盈宝发送的日、月电子结单邮件",
    howToViewFeeDetailDesc12:"登录盈宝App → “我的” → “我的结单” → “组合”栏目，通过结单查看详细费用明细",
    isIncludeDivideForProfit:"投资组合收益是否包含分红派息",
    isIncludeDivideForProfitDesc:"投资组合收益包含分红派息和资本增值（即投资组合本身资产升值）。",
    howToViewDivide:"如何查看投资组合的分红派息",
    howToViewDivideDesc1:"可以在持有组合详情页查看，或者通过结单查看",
    capitalUseInmedia:"卖出投资组合，资金可否立即使用",
    capitalUseInmediaDesc1:"赎回资金需等待交易执行完成及资金交收完毕后方可再次使用或转出。具体交收时间取决于组合主要持仓市场：",
    capitalUseInmediaDesc11:"全部为香港市场标的 → T+2 日交收",
    capitalUseInmediaDesc12:"全部为美国市场标的 → T+1 日交收",
    capitalUseInmediaDesc13:"同时持有香港及美国市场标的 → 统一按T+2 日交收",
    capitalUseInmediaDesc1Tip:"（T指赎回指令成交日，实际到账时间以清算机构确认为准）",
    canFinanceBuyPortfolio:"是否可以融资买入投资组合",
    canFinanceBuyPortfolioDesc:"目前暂不支持融资买入投资组合。我们会持续关注市场需求，适时推出相关功能，敬请留意后续公告。",
    jingxuanyinglun:"精选英伦",
    openPortfolioimedia:"一键开通投资组合",
    startToInvest:"开始组合投资",
    assetValueUsd:"资产净值(USD)",
    dollar:"美元",
    nomalQuestion:"常见问题",
    aiInsight:"组合洞察"
   },
   investProtocol:{
    investmentProtocol:"推荐投资协议",
    agreenProtocol:"同意协议",
    sumitSuccess:"提交成功",
    confirmAgreenProtocol:"确认是否同意协议？",
    investmentAdvisoryProtocol:"投资顾问协议"
   },
   magicNineTurns:{
    title1:"指标简介",
    introduction1:"神奇九转指标（TD Sequential）由著名技术分析大师 Tom DeMark 提出，是一类基于价格行为的趋势节奏分析指标。其核心思想在于：价格趋势并非无限延续，当股价在同一方向持续运行时，市场内在动能将逐步消耗，趋势进入衰竭阶段的概率随之上升。",
    introduction2:"该指标主要用于识别趋势后期可能出现的节奏变化或拐点风险，为投资者在上涨或下跌行情中提供风险提示和决策参考，而非对短期走势作出确定性预测。",
    title2:"指标基本结构",
    structure1:"神奇九转通过对价格相对位置进行连续计数，构建趋势序列结构：",
    structure2:"当前K线的收盘价高于（或低于）前第4根K线的收盘价；",
    structure3:"且该条件连续满足 9 根 K 线；",
    structure4:"则形成一个完整的上涨九转或下跌九转序列。",
    structure5:"在实际展示中，当计数进行至第 6 根 K 线时，序列信号开始出现；",
    structure6:"若在后续第 7、8、9 根 K 线中条件不再满足，则该九转序列自动失效并消失，表明趋势节奏尚未完成。",
    title3:"指标应用",
    application1:"九转信号并不代表趋势必然立即反转，而是提示当前行情可能进入高波动或高风险阶段，市场更容易出现震荡整理或趋势结构变化。",
    application2:"从本质上看，神奇九转用于刻画趋势过度延续与情绪偏离的状态，适合辅助判断市场是否处于过度乐观或悲观区间。在实际应用中，建议结合基本面、市场环境及关键价位进行综合分析，以提升判断的稳健性。"
   },
   article: {
    articleErr: '文章加载失败，请稍后重试',
    author: '作者',
    comment: '评论',
    noComment: '暂无评论',
    writeComment: '写评论',
    openAppToReadBetter: '打开盈宝证券App，更佳阅读体验',
    remainingText1: '还有剩余',
    remainingText2: '%的精彩内容！',
    disclaimer:
      '免责声明：上述内容仅为发布者个人观点，不构成盈宝或本社区的任何投资建议，盈宝或本社区不承担因上述发布者言论引起的任何损失和损害。',
    pay: '支付',
    wbCoin: '盈宝币',
    followAuthor: '关注作者',
    continueRead: '继续阅读',
    reply: '回复',
    minuteAgo: '分钟前',
    hoursAgo: '小时前',
    daysAgo: '天前',
    justNow: '刚刚',
    anonymous: '匿名',
    longPic: '长图',
    modifyOn: '修改于',
    toDay:"今日",
    yesterday :"昨天",
    disclaimer2:"免责声明：上述内容仅为发布者个人观点，仅供参考，不构成任何投资建议。",
  },
  shortSelling:{
    riskProtocol:"风险协议",
    financeSecurityProtocol: "融券协议"
  },
  shanghaiHkShenzhen:{
    connectTitle:"沪港通&深港通",
    desc1:"沪港通、深港通，是连接中国内地与香港资本市场的“投资桥梁”，它既让内地投资者可以直接投资港股，也让香港、境外资金参与A股市场，是一套双向开放的互联互通机制。",
    desc2:"在沪港通、深港通体系中，内地投资者投资港股的通道被称为港股通（或南向通），只有被纳入“港股通标的名单”的港股，才可以通过该通道进行交易。",
    desc3:"并非所有港股都支持港股通交易，一般而言，纳入港股通（即“入通”）需满足以下核心条件：",
    desc31:"市值与规模：通常属于恒生综合指数成分股，以大盘股和中盘股为主；",
    desc32:"流动性：日均成交活跃，具备良好的买卖深度；",
    desc33:"交易状态：正常交易（非长期停牌），无重大风险或异常情况；",
    desc4:"港股通标的实行动态管理机制，一般情况下，每年在3月和9月会调整港股通名单，包括新纳入和剔除，部分大型IPO公司上市后较快被纳入恒生指数，从而快速入通。",
    desc5:"当一只港股被纳入港股通，意味着其进入内地资金（南向资金，也称“北水”）的投资范围，通常会带来流动性提升，并可能对股价和估值产生阶段性影响。"
  },

  usOptionTeach:{
    usOptionTeach:"期权教学"
  },
  ipoAnalysis:{
    aiAnalysisDetail:"AI评级明细",
    analysisTime:"分析时间",
    tip:"温馨提示：本内容由AI基于公开市场信息、IPO相关数据分析生成，AI评级结果可能跟随市场申购热度、AH折溢价率等动态调整，不代表任何投资建议。",
    applicationRating:"申购评级",
    comprehensiveRating:"综合评分",
    demension:"维度",
    score:"评分",
    coreJudgement:"核心判断",
    conclusion:"结论",
    goToSub:"前往认购"
  },
  aiPortfoliInsight:{
    insightTip:"温馨提示：当前内容仅供参考，不构成投资建议。"
  }
}